import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '分类', path: '/category/all' },
  { label: '排行榜', path: '/#ranking' },
  { label: '关于我们', path: '/about' },
];

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      window.REACT_APP_NAVIGATE?.(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between px-6 md:px-10 h-16 max-w-[1440px] mx-auto" aria-label="主导航">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap"
        >
          <span className="text-xl md:text-2xl font-display font-bold text-primary-600">
            073漫画
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === link.path
                  ? 'text-primary-600'
                  : isScrolled
                    ? 'text-foreground-700 hover:text-primary-600'
                    : 'text-white/90 hover:text-white'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <form onSubmit={handleSearch} className="relative">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="搜索漫画..."
              className="w-48 px-3 py-1.5 pr-8 rounded-full text-sm bg-background-100/80 border border-background-200/80 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-all duration-200"
            />
            <button
              type="submit"
              className="absolute right-2 top-1/2 -translate-y-1/2 text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-sm w-4 h-4 flex items-center justify-center"></i>
            </button>
          </form>
        </div>

        <button
          className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg cursor-pointer"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="菜单"
        >
          <i
            className={`text-xl w-5 h-5 flex items-center justify-center ${
              isScrolled ? 'text-foreground-800' : 'text-white'
            } ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}
          ></i>
        </button>
      </nav>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-6 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium py-2 ${
                  location.pathname === link.path
                    ? 'text-primary-600'
                    : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <form onSubmit={handleSearch} className="mt-2">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索漫画..."
                className="w-full px-4 py-2 rounded-full text-sm bg-background-100 border border-background-200 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400"
              />
            </form>
          </div>
        </div>
      )}
    </header>
  );
}